import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import RouteNotFound  from "../../Utils/routeNotFound";

interface CustomRoutesProps {
  routes: Array<any>;
  role?: string;
  exact: {
    path: string;
    route: string;
  };
}

export default class CustomRoutes extends React.Component<CustomRoutesProps> {
  render() {
    return (
      <Switch>
        {(this.props.routes || [])
          //   .filter((f) => f.rolesAccepted.includes(this.props.role))
          .map((route) => (
            <Route key={route.path} path={route.path} component={route.component} />
          ))}
        <Route
          path={this.props.exact.path}
          exact
          render={(props) => <Redirect to={this.props.exact.route} />}
        />
        {/* <Route path="*" component={RouteNotFound} /> */}
      </Switch>
    );
  }
}
